import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";

import { fetchPost } from "../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import CustomInput from "../Common/CustomInput";
import CustomButton from "../Common/CustomButton";
import AddIcon from "../Common/AddIcon";
import Note from "../Common/Note";

import { formatDate } from "../../utils/date";
import { isAllowed } from "../../utils/users";

import colors from "../../assets/style/colors";
import CustomSelect from "../Common/CustomSelect";
import { getNoteType } from "../../utils/noteType";

const styles = (theme) => ({
  card: {
    backgroundColor: colors.white,
    height: "calc(100% - 24px)",
    overflow: "auto",
    borderRadius: "2px",
    [theme.breakpoints.up("sm")]: {
      maxHeight: "calc(100vh - 200px)",
      height: "calc(100vh - 200px)",
      margin: "12px",
      boxShadow: "0px 2px 2px 0px " + colors.black23,
    },
    [theme.breakpoints.down("sm")]: {
      margin: "12px 6px",
      maxHeight: "calc(100vh - 160px)",
      height: "calc(100vh - 160px)",
    },
  },
  contentContainer: {
    [theme.breakpoints.up("sm")]: {
      width: "650px",
      padding: "24px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
    },
  },
});

const ProfileNotes = (props) => {
  const { notes, isMe, permissions } = props;
  const [editMode, setEditMode] = React.useState(false);
  const [newNoteDesc, setNewNoteDesc] = React.useState("");
  const [noteType, setNoteType] = React.useState(1);
  const [noteTypeOptions,setNoteTypeOptions]=React.useState([]);

  React.useEffect(()=>{
    const fetchNoteType= async()=>{
      let value =await getNoteType()
      setNoteTypeOptions(value)
    }

    fetchNoteType()
  },[])
  const saveNote = async () => {
    setEditMode(false);
    try {
      let newNote = await fetchPost("profiles/" + props.profileId + "/notes", {
        description: newNoteDesc,
        sys_note_type_id:noteType
      });
      newNote.author = props.user.firstName + " " + props.user.lastName;
      props.addNewNoteToProfile(newNote);
    } catch (e) {
      console.log(e);
    }
    setNewNoteDesc("");
  };

  const getNoteTypeValue=(id)=>{
    for(let val of noteTypeOptions){
      if(val.id===id) return val.name
    }
    return ""
  }
  return (
    <Box className={props.classes.card}>
      <Grid
        container
        direction="column"
        className={props.classes.contentContainer}
      >
        <Grid item>
          <AddIcon
            handleClick={() => setEditMode(true)}
            disabled={
              editMode || (isMe && !isAllowed(permissions, "me.notes.create"))
            }
          />
        </Grid>
        {editMode && (
          <>
          <Grid item style={{ marginBottom: "10px" }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item className="text-54">
                {I18n.get("site_noteType")}
              </Grid>
              <Grid item style={{ width: "200px" }}>               
                <CustomSelect
                  name="noteType"
                  value={noteType}
                  onChange={(e) => setNoteType(e.target.value)}
                  options={noteTypeOptions}
                />
              </Grid>
            </Grid>
          </Grid>
            <Grid item style={{ marginTop: "10px" }}>
              <CustomInput
                name="description"
                value={newNoteDesc}
                onChange={(e) => setNewNoteDesc(e.target.value)}
                multiline={true}
                rows={5}
              />
            </Grid>
            <Grid item style={{ textAlign: "right" }}>
              <CustomButton
                color="primary"
                style={{ margin: "10px 10px 0px 0px" }}
                onClick={() => setEditMode(false)}
              >
                {I18n.get("site_cancel")}
              </CustomButton>
              <CustomButton
                variant="contained"
                color="primary"
                style={{ marginTop: "10px" }}
                disabled={newNoteDesc ? false : true}
                onClick={saveNote}
              >
                {I18n.get("site_save")}
              </CustomButton>
            </Grid>
          </>
        )}
        {notes &&
          notes
            .sort(
              (a, b) =>
                new Date(b.updated_on).getTime() -
                new Date(a.updated_on).getTime()
            )
            .map((note) => (
              <Grid item key={note.id}>
                <hr
                  style={{
                    borderLeft: "none",
                    margin: "25px",
                    color: "black",
                    opacity: "0.3",
                  }}
                />
                <Note
                  author={note.author || ""}
                  date={formatDate(note.updated_on)}
                  description={note.description}
                  noteType={getNoteTypeValue(note.sys_note_type_id)}
                />
              </Grid>
            ))}
      </Grid>
    </Box>
  );
};

ProfileNotes.propTypes = {
  notes: PropTypes.array.isRequired,
  profileId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(ProfileNotes));
